import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { LoginSectionComponent } from './login-section/login-section.component';
import { AppSharedModule } from '../app-shared.module';
import { GlobalFeedbackComponent } from './feedbacks/global-feedback/global-feedback.component';
import { FeedbackSummaryComponent } from './feedbacks/feedback-summary/feedback-summary.component';
import { AddFeedbackComponent } from './feedbacks/add-feedback/add-feedback.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { FeedbackPipes } from '../shared/pipes/feedback.pipe';



@NgModule({
  declarations: [
    LoginSectionComponent,
    GlobalFeedbackComponent,
    FeedbackSummaryComponent,
    AddFeedbackComponent,
    FeedbackPipes
  ],
  imports: [
    CommonModule,
    NgbModule,
    NgOptimizedImage,
    AppSharedModule,
    NgMultiSelectDropDownModule,
    FormsModule
  ],
  exports: [
    LoginSectionComponent
  ]
})
export class DashbordModule { }
